import React from 'react'
import Flex from 'components/reusable/flex'
import SvgUpRightArrow from 'components/reusable/svg/svg_up_right_arrow'
import Text from 'components/reusable/text'
import styled from 'styled-components'
import { colors } from 'helpers/colors'

const responsiveTitleSize = [{ maxWidth: 768, size: 16 }, { size: 20 }]
const responsiveDescSize = [{ maxWidth: 768, size: 14 }, { size: 16 }]

const ArrowWrapper = styled(Flex)`
  padding-top: 5px;
`

const BenefitsListFlex = styled(Flex)`
  @media (max-width: 768px) {
    gap: 12px;
  }
  @media (min-width: 769px) {
    gap: 16px;
  }
`

const BenefitItemColumn = styled(Flex)`
  @media (max-width: 768px) {
    gap: 2px;
  }
  @media (min-width: 769px) {
    gap: 4px;
  }
`

export const benefitsData = {
  talent: [
    {
      title: 'Invite clients and earn $50',
      description: 'when they complete their first booking'
    },
    {
      title: 'Invite talent and earn $25',
      description: 'when they book their first job'
    }
  ],
  client: [
    {
      title: 'Cast projects together',
      description: '(coming soon)'
    },
    {
      title: '$50 credit per client referral',
      description: 'after they complete their first booking'
    },
    {
      title: '$25 credit per talent referral',
      description: 'after they book their first job'
    },
  ]
}

const defaultBenefits = [
  {
    title: 'Grant exclusive access',
    description: 'to your friends'
  },
  {
    title: 'Cast projects together',
    description: '(coming soon)'
  },
  {
    title: '$50 credit',
    description: 'after they complete their first booking'
  }
]

const BenefitsList = ({ benefits, role }) => {
  const benefitsToRender = benefits || (role ? benefitsData[role] : defaultBenefits)

  return (
    <BenefitsListFlex dir="column" ai="flex-start" jc="flex-start">
      {benefitsToRender.map((benefit, index) => (
        <Flex key={index} dir="row" ai="flex-start" gap={4}>
          <ArrowWrapper ai="center" jc="center" width={20} height={20}>
            <SvgUpRightArrow size={10} color={colors.primary[500]} />
          </ArrowWrapper>
          <BenefitItemColumn dir="column" ai="flex-start" jc="flex-start">
            <Text size={responsiveTitleSize} weight={500} lineHeight="140%">{benefit.title}</Text>
            <Text size={responsiveDescSize} lineHeight="140%">{benefit.description}</Text>
          </BenefitItemColumn>
        </Flex>
      ))}
    </BenefitsListFlex>
  )
}

export default BenefitsList
